var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconWallet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 4L4.98755 6.49755C4.40942 6.62304 4 7.13071 4 7.72365V18.7451C4 19.4384 4.55937 20 5.25 20H19V16.2353H15.5625C14.9563 16.2353 14.4127 15.9903 14.0159 15.5919C13.619 15.1935 13.375 14.6478 13.375 14.0392C13.375 12.8251 14.3531 11.8431 15.5625 11.8431H19V8.07843H5.875V7.45098L16.5 6.47243V4ZM15.875 13.098C15.6264 13.098 15.3879 13.1972 15.2121 13.3737C15.0363 13.5502 14.9375 13.7896 14.9375 14.0392C14.9375 14.2888 15.0363 14.5282 15.2121 14.7047C15.3879 14.8812 15.6264 14.9804 15.875 14.9804C16.1236 14.9804 16.3621 14.8812 16.5379 14.7047C16.7137 14.5282 16.8125 14.2888 16.8125 14.0392C16.8125 13.7896 16.7137 13.5502 16.5379 13.3737C16.3621 13.1972 16.1236 13.098 15.875 13.098Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWallet);
export default __webpack_public_path__ + "static/media/icon-wallet.f071793be95930db4ec0d39af487a36e.svg";
export { ForwardRef as ReactComponent };